(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amencore-mixed-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const GROUP = 'ebms-jtms-pms-v1';
  const IDS = ['43291697709118', '46210025979966', '46210026274878'];
  if (window.__acMixedRuntimeMounted) return;
  window.__acMixedRuntimeMounted = true;
  const controllers = new Map();
  const endpoint = name => (window.Shopify?.routes?.root || '/') + 'cart/' + name + '.js';
  // Include the configured zero-threshold gift in the same native add request.
  // The empty-cart Liquid guard remains in place: it must not add a gift by itself.
  let giftOwner = null;
  document.addEventListener('formdata', event => {
    const form = event.target;
    const productForm = form instanceof Element && form.closest('product-form.main-product-form');
    const handles = ['the-entire-bible-made-simple','the-entire-bible-made-simple-dupe','the-entire-bible-made-simple-active','the-entire-bible-made-simple-copy-1','bible-made-simple-for-kids-1','bible-made-simple-for-kids-2'];
    if (!productForm || !handles.some(handle => window.location.pathname.endsWith('/products/' + handle))) return;
    const drawer = document.querySelector('cart-drawer');
    const gift = drawer && [...drawer.querySelectorAll('cart-drawer-gift[data-handle="free-gifts"]')].find(item => {
      const requirement = item.getAttribute('data-requirement');
      return requirement !== null && requirement.trim() !== '' && Number(requirement) === 0;
    });
    if (!gift?.dataset.id || drawer.querySelector('.cart-item--product-free-gifts')) return;
    const data = event.formData;
    const entries = [...data.entries()];
    const ids = entries.filter(([key]) => /^items\[\d+\]\[id\]$/.test(key));
    if (!ids.some(([,id]) => String(id) !== gift.dataset.id) && !data.get('id')) return;
    if (giftOwner && giftOwner.submitButton?.getAttribute('aria-disabled') !== 'true') giftOwner = null;
    if (giftOwner && giftOwner !== productForm) {
      for (const [key,id] of ids) if (String(id) === gift.dataset.id) {
        const prefix = key.slice(0,-4);
        for (const [field] of entries) if (field.startsWith(prefix + '[')) data.delete(field);
      }
      return;
    }
    giftOwner = productForm;
    if (ids.some(([,id]) => String(id) === gift.dataset.id)) return;
    let last = ids.reduce((max,[key]) => Math.max(max,Number(key.match(/^items\[(\d+)\]/)[1])), -1);
    if (!ids.length) {
      // Preserve all main-item fields when converting a single-item payload.
      last = 0;
      data.set('items[0][id]',data.get('id'));
      data.set('items[0][quantity]',data.get('quantity') || String(productForm.quantityBreaks?.selectedQuantity || 1));
      if (data.get('selling_plan')) data.set('items[0][selling_plan]',data.get('selling_plan'));
      for (const [key,value] of entries) if (/^properties\[[^\]]+\]$/.test(key)) data.set('items[0][properties][' + key.slice(11,-1) + ']',value);
      data.delete('id'); data.delete('quantity'); data.delete('selling_plan');
      for (const [key] of entries) if (key.startsWith('properties[')) data.delete(key);
    }
    data.set(`items[${last+1}][id]`,gift.dataset.id);
    data.set(`items[${last+1}][quantity]`,'1');
  },true);
  function selected(root) {
    return root.querySelector('input[type="radio"]:checked:not(:disabled)');
  }
  function rewriteBundle(data) {
    const entries = [...data.entries()];
    let mainIndex = null;
    let maxIndex = -1;
    for (const [name, value] of entries) {
      const match = name.match(/^items\[(\d+)\]\[id\]$/);
      if (!match) continue;
      maxIndex = Math.max(maxIndex, Number(match[1]));
      if (String(value) === IDS[0]) mainIndex = Number(match[1]);
    }
    if (mainIndex === null && String(data.get('id')) === IDS[0]) {
      mainIndex = ++maxIndex;
      data.set(`items[${mainIndex}][id]`, IDS[0]);
      if (data.get('selling_plan')) data.set(`items[${mainIndex}][selling_plan]`,data.get('selling_plan'));
      for (const [name, value] of entries) {
        if (/^properties\[[^\]]+\]$/.test(name)) {
          data.set(`items[${mainIndex}][properties][${name.slice(11, -1)}]`, value);
        }
      }
    }
    if (mainIndex === null) throw new Error('The selected book could not be found. Please refresh.');
    data.delete('id');
    data.delete('quantity');
    const indexes = [mainIndex, ++maxIndex, ++maxIndex];
    const mainProperties = [...data.entries()].filter(([name]) => name.startsWith(`items[${mainIndex}][properties]`));
    mainProperties.forEach(([name]) => data.delete(name));
    const orderedIds = IDS;
    orderedIds.forEach((id, i) => {
      const prefix = `items[${indexes[i]}]`;
      if (id === IDS[0]) mainProperties.forEach(([name,value]) => data.set(name.replace(`items[${mainIndex}]`,prefix),value));
      data.set(prefix + '[id]', id);
      data.set(prefix + '[quantity]', '1');
      data.set(prefix + '[properties][_ac_mixed_bundle]', GROUP);
      data.delete(prefix + '[properties][_ac_mixed_instance]');
    });
  }
  function mount(root) {
    if (controllers.has(root)) return;
    const form = document.getElementById(root.dataset.form);
    const productForm = form?.closest('product-form');
    if (!form || !productForm || typeof productForm.handleSubmit !== 'function') return;
    const error = root.querySelector('[data-mixed-error]');
    const original = productForm.handleSubmit;
    const abort = new AbortController();
    const options = { signal: abort.signal };
    let pending = false;
    let submitting = false;
    let buttonStates = [];
    let lastSubmittedChoice = '';
    function releaseLoading() {
      productForm.submitButton?.removeAttribute('aria-disabled');
      for (const {button,disabled} of buttonStates) {
        button.toggleAttribute('disabled',disabled);
        button.classList.remove('loading');
      }
      productForm.loadingSpinner?.classList.add('hidden');
      submitting = false;
    }
    function showError(message) {
      if (error) { error.textContent = message; error.hidden = !message; }
    }
    function syncCartPrices() {
      const counts = document.querySelector('cart-drawer [data-ac-mixed-cart-counts]');
      const prices = root.querySelector('[data-ac-mixed-prices]')?.dataset;
      if (!counts || !prices) return;
      const e = Number(counts.dataset.e), j = Number(counts.dataset.j), p = Number(counts.dataset.p);
      if (![e,j,p].every(Number.isSafeInteger)) return;
      const used = Math.min(e,j,p,3);
      const singleDiscounted = Math.min(e+1,j,p,3) > used;
      const capped = used >= 3;
      const write = (node,text) => {if (node && node.textContent !== text) node.textContent = text;};
      const single = root.querySelector('[data-choice="single"]');
      const bundle = root.querySelector('[data-choice="bundle"]');
      if (single) {
        single.dataset.total = singleDiscounted ? prices.singleDiscount : prices.single;
        single.setAttribute('aria-label','1 Book — ' + single.dataset.total);
        const label = single.closest('label');
        write(label.querySelector('.ac-price'),single.dataset.total);
        write(label.querySelector('[data-ac-total]'),single.dataset.total);
        write(label.querySelector('.ac-save strong'),singleDiscounted ? prices.singleDiscountSaving : prices.singleSaving);
        write(label.querySelector('.ac-single-off'),(singleDiscounted ? prices.singleDiscountPercent : '35') + '% off');
      }
      if (bundle) {
        bundle.dataset.total = capped ? prices.full : prices.bundle;
        const label = bundle.closest('label');
        bundle.setAttribute('aria-label',label.querySelector('.ac-name').textContent + ' — ' + bundle.dataset.total);
        write(label.querySelector('.ac-main-price'),bundle.dataset.total);
        write(label.querySelector('[data-ac-total]'),bundle.dataset.total);
        write(label.querySelector('.ac-bundle-savings strong'),capped ? prices.fullSaving : prices.bundleSaving);
        write(label.querySelector('.ac-off'),(capped ? prices.fullPercent : '55') + '% off');
        write(label.querySelector('.ac-item-price'),capped ? prices.single : prices.singleDiscount);
      }
    }
    function sync() {
      syncCartPrices();
      root.selectedQuantity = 1;
      root.formVariants = [];
      const input = selected(root);
      if (!input) return;
      root.selectedOffer = input.dataset.choice === 'bundle' ? 2 : 1;
      document.querySelectorAll('[data-ac-cta-total]').forEach(holder => {
        if (holder.dataset.acSection !== root.dataset.section) return;
        holder.hidden = holder.closest('button')?.dataset.unavailable === 'true';
        const amount = holder.querySelector('[data-ac-cta-amount]');
        const compare = holder.querySelector('[data-ac-cta-compare]');
        if (amount && amount.textContent !== input.dataset.total) amount.textContent = input.dataset.total;
        if (compare) { if (compare.textContent !== input.dataset.compare) compare.textContent = input.dataset.compare; compare.hidden = false; }
      });
    }
    function formData(event) {
      sync();
      if (selected(root)?.dataset.choice === 'bundle') {
        try { rewriteBundle(event.formData); }
        catch (err) {
          // A formdata listener exception alone does not cancel the native request.
          // Invalidate the whole payload instead of sending only some selected products.
          for (const name of [...event.formData.keys()]) event.formData.delete(name);
          event.formData.set('items[0][id]','0');
          event.formData.set('items[0][quantity]','1');
          showError(err.message || 'Could not prepare this offer. Please refresh.');
        }
      }
    }
    async function submit(event) {
      event?.preventDefault();
      event?.stopImmediatePropagation();
      if (pending || productForm.submitButton?.getAttribute('aria-disabled') === 'true') return;
      sync();
      const choice = selected(root)?.dataset.choice;
      if (!choice) return;
      if (choice === 'bundle' && String(form.querySelector('[name="id"]')?.value) !== IDS[0]) {
        showError('The selected book has changed. Please refresh this page.');
        return;
      }
      pending = true;
      submitting = true;
      lastSubmittedChoice = choice;
      buttonStates = [...new Set([productForm.submitButton,productForm.displayedSubmitButton,...(productForm.additionalAtcButtons || [])].filter(Boolean))].map(button => ({button,disabled:button.hasAttribute('disabled')}));
      showError('');
      root.setAttribute('aria-busy', 'true');
      try {
        sync();
        original.call(productForm, event || null);
      } catch (err) {
        releaseLoading();
        showError(err.message || 'Could not add this offer. Please try again.');
      } finally {
        pending = false;
        root.removeAttribute('aria-busy');
      }
    }
    productForm.handleSubmit = submit;
    form.addEventListener('submit', submit, {...options,capture:true});
    form.addEventListener('formdata', formData, options);
    root.addEventListener('change', () => {
      if (lastSubmittedChoice === 'bundle' && selected(root)?.dataset.choice === 'single' && productForm.error === true) {
        productForm.error = false;
        releaseLoading();
        productForm.submitButton?.querySelector('.sold-out-message')?.classList.add('hidden');
        productForm.submitButton?.querySelector('span')?.classList.remove('hidden');
        productForm.handleErrorMessage?.();
      }
      showError('');sync();
    }, options);
    window.addEventListener('pageshow', event => {
      if (event.persisted && submitting) {
        releaseLoading();
      }
      pending = false; root.removeAttribute('aria-busy'); sync();
    }, options);
    form.addEventListener('reset', () => queueMicrotask(sync), options);
    const bundle = root.querySelector('input[data-choice="bundle"]');
    if (bundle && bundle.dataset.ready === 'true' && IDS.every((id,i) => id === [root.dataset.mainId,root.dataset.jtmsId,root.dataset.pmsId][i])) {
      bundle.disabled = false;
      if (!root.dataset.acInitialized) bundle.checked = true;
    }
    root.dataset.acInitialized = 'true';
    const observer = new MutationObserver(() => {
      if (productForm.submitButton?.getAttribute('aria-disabled') !== 'true') submitting = false;
      sync();
    });
    observer.observe(form,{subtree:true,childList:true,attributes:true,attributeFilter:['data-unavailable','aria-disabled']});
    const cartObserver = new MutationObserver(sync);
    const drawer = document.querySelector('cart-drawer');
    if (drawer) cartObserver.observe(drawer,{subtree:true,childList:true});
    controllers.set(root,() => {
      abort.abort(); observer.disconnect(); cartObserver.disconnect();
      if (productForm.handleSubmit === submit) productForm.handleSubmit = original;
      controllers.delete(root);
    });
    sync();
  }
  function boot() {
    for (const [root,dispose] of controllers) if (!root.isConnected) dispose();
    document.querySelectorAll('[data-ac-mixed]').forEach(mount);
  }
  customElements.whenDefined('product-form').then(boot);
  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',event => {
    for (const [root,dispose] of controllers) if (event.target.contains(root)) dispose();
  });
  const changes = new Map();
  let changing = false;
  let pageVersion = 0, pageSuspended = false, reconcileAfterDrain = false;
  let drainPromise = null;
  let changeFailure = '';
  let checkoutPending = false;
  let resumingCheckout = false;
  const errorNode = () => document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
  function cartError(message) { const node = errorNode(); if (node) node.textContent = message; }
  async function boundedRequest(url, options, parse = 'json') {
    const controller = new AbortController();
    let timer;
    try {
      return await Promise.race([
        (async () => {
          const response = await fetch(url, {...options, signal:controller.signal});
          const data = await response[parse]();
          return {response, data};
        })(),
        new Promise((_, reject) => { timer = setTimeout(() => { controller.abort(); reject(Error('The cart request timed out. Please refresh your cart.')); }, 15000); })
      ]);
    } finally { clearTimeout(timer); }
  }
  async function cartRequest(name, body) {
    const {response,data} = await boundedRequest(name === 'read' ? (window.Shopify?.routes?.root || '/') + 'cart.js' : endpoint(name),
      body ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {cache:'no-store'});
    if (!response.ok || data.status || data.errors) throw new Error(data.description || (typeof data.errors === 'string' ? data.errors : '') || 'Could not update your cart. Please try again.');
    return data;
  }
  function resolveItem(cart, job) {
    const exact = cart.items.find(item => item.key === job.key);
    if (exact) return exact;
    const candidates = cart.items.filter(item => String(item.variant_id) === job.variant &&
      item.properties?._ac_mixed_bundle === GROUP && (item.properties?._ac_mixed_instance || '') === job.instance);
    if (candidates.length === 1) return candidates[0];
    // Shopify can split identical variants by discount price and change both keys.
    const samePrice = candidates.filter(item => String(item.final_price) === job.unitPrice);
    return samePrice.length === 1 ? samePrice[0] : null;
  }
  function sectionIds() {
    const drawer = document.querySelector('cart-drawer');
    const page = document.querySelector('cart-items');
    return [...new Set([
      ...(drawer?.getSectionsToRender().map(section => section.id) || []),
      ...(page?.getSectionsToRender?.().map(section => section.section) || [])
    ])].filter(Boolean);
  }
  async function readSections() {
    const url = new URL(window.location.href);
    url.searchParams.delete('section_id');
    url.searchParams.set('sections',sectionIds().join(','));
    const {response,data} = await boundedRequest(url.href,{cache:'no-store'});
    if (!response.ok) throw new Error('Could not refresh the cart.');
    return data;
  }
  async function refreshCart(cart) {
    const lifecycle = pageVersion;
    const drawer = document.querySelector('cart-drawer');
    const page = document.querySelector('cart-items');
    const sections = sectionIds();
    if (sections.some(id => !cart.sections?.[id])) cart.sections = await readSections();
    if (pageSuspended || lifecycle !== pageVersion) return;
    if (sections.some(id => !cart.sections?.[id])) throw new Error('Could not refresh the cart. Please try again.');
    if (drawer) {
      for (const section of drawer.getSectionsToRender()) {
        if (!new DOMParser().parseFromString(cart.sections[section.id], 'text/html').querySelector(section.selector || '.shopify-section')) throw new Error('Could not refresh the cart.');
      }
      const parsed = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html');
      if (!parsed.querySelector('#CartDrawer')) throw new Error('Could not refresh the cart.');
      if (drawer.querySelector('[data-ac-oct16-bundle]')) {
        const bundle = parsed.querySelector('[data-ac-oct16-bundle]');
        const state = JSON.parse(bundle?.querySelector('[data-ac-variant-cart-state]')?.textContent || 'null');
        if (!Array.isArray(state?.cart?.items) || !['native','challenger'].every(name => bundle.querySelector('[data-ac-oct16-'+name+']')?.content?.querySelector('#CartDrawer'))) throw new Error('Could not refresh the cart.');
      }
    }
    if (page) for (const section of page.getSectionsToRender()) {
      if (!new DOMParser().parseFromString(cart.sections[section.section], 'text/html').querySelector(section.selector)) throw new Error('Could not refresh the cart.');
    }
    drawer?.classList.toggle('is-empty',cart.item_count === 0);
    // Keep an intentionally closed drawer closed while updating its contents.
    drawer?.renderContents(cart,true);
    if (page) {
      for (const section of page.getSectionsToRender()) {
        const container = document.getElementById(section.id);
        const target = container?.querySelector(section.selector) || container;
        if (target) target.innerHTML = page.getSectionInnerHTML(cart.sections[section.section],section.selector);
      }
      page.classList.toggle('is-empty',cart.item_count === 0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty',cart.item_count === 0);
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items',cartData:cart});
  }
  async function drainChanges() {
    if (changing) return;
    changing = true;
    const version = pageVersion;
    const surfaces = [...document.querySelectorAll('cart-drawer, cart-items')];
    surfaces.forEach(node => node.setAttribute('data-ac-mixed-mutating','true'));
    changeFailure = '';
    cartError('');
    let latest = null, failure = '';
    try {
      while (changes.size) {
        if (pageSuspended || version !== pageVersion) { reconcileAfterDrain = true; break; }
        const [identity,job] = changes.entries().next().value;
        changes.delete(identity);
        job.row.setAttribute('aria-busy','true');
        try {
          const cart = await cartRequest('read');
          if (pageSuspended || version !== pageVersion) { reconcileAfterDrain = true; break; }
          const item = resolveItem(cart,job);
          if (!item || item.properties?._ac_mixed_bundle !== GROUP || !IDS.includes(String(item.variant_id))) {
            if (job.quantity === 0) { latest = cart; continue; }
            throw new Error('Your cart changed. Refresh the cart before changing this book again.');
          }
          const sections = sectionIds();
          // change.js validates available inventory; update.js does not validate existing quantities.
          const lastPaidRemoval = job.quantity === 0 && cart.items.every(line => line.key === item.key || line.handle === 'free-gifts');
          if (lastPaidRemoval) {
            const updates = Object.fromEntries(cart.items.map(line => [line.key,0]));
            latest = await cartRequest('update',{updates,sections,sections_url:window.location.pathname});
          } else {
            latest = await cartRequest('change',{id:item.key,quantity:job.quantity,sections,sections_url:window.location.pathname});
          }
          if (pageSuspended || version !== pageVersion) { reconcileAfterDrain = true; break; }
          if (latest.items.length && latest.items.every(line => line.handle === 'free-gifts')) {
            const updates = Object.fromEntries(latest.items.map(line => [line.key,0]));
            latest = await cartRequest('update',{updates,sections,sections_url:window.location.pathname});
          }
        } catch (err) {
          if (pageSuspended || version !== pageVersion) { reconcileAfterDrain = true; break; }
          failure = err.message || 'Could not update your cart. Please try again.';
          const input = job.row.querySelector('.quantity__input');
          if (input) input.value = input.defaultValue;
          changes.clear();
          latest = null;
          try {
            const current = await cartRequest('read');
            current.sections = await readSections();
            if (pageSuspended || version !== pageVersion) { reconcileAfterDrain = true; break; }
            await refreshCart(current);
            const observed = resolveItem(current, job);
            if (job.quantity === 0 ? Boolean(observed) : Number(observed?.quantity) !== job.quantity) restoreFailed = true;
          } catch (_) {
            if (pageSuspended || version !== pageVersion) { reconcileAfterDrain = true; break; }
            restoreFailed = true;
            failure = 'Your cart may have updated. Please refresh the cart before making another change.';
          }
          break;
        } finally { job.row.removeAttribute('aria-busy'); }
      }
      if (latest && !pageSuspended && version === pageVersion) await refreshCart(latest);
    } catch (err) {
      if (pageSuspended || version !== pageVersion) reconcileAfterDrain = true;
      else {
        restoreFailed = true;
        failure = err.message || 'Could not refresh your cart. Please reload the page.';
      }
    }
    finally {
      changing = false;
      surfaces.forEach(node => node.removeAttribute('data-ac-mixed-mutating'));
      const current = !pageSuspended && version === pageVersion;
      changeFailure = current ? failure : '';
      if (current && failure) { if(restoreFailed)surfaces.forEach(node => node.setAttribute('data-ac-cart-uncertain','true')); cartError(failure); if (restoreFailed) addRefreshButton(); }
    }
  }
  function startDrain() {
    if (!drainPromise) {
      drainPromise = drainChanges().finally(() => {
        drainPromise = null;
        if (changes.size) startDrain();
        else if (reconcileAfterDrain && !pageSuspended) { reconcileAfterDrain = false; restoreCart(); }
      });
    }
    return drainPromise;
  }
  function enqueue(row,quantity) {
    const job = {row,key:row.dataset.acLineKey,variant:row.dataset.acVariantId,instance:row.dataset.acMixedInstance || '',unitPrice:row.dataset.acUnitPrice || '',quantity};
    const identity = job.instance ? job.instance + ':' + job.variant : job.key;
    changes.set(identity,job);
    startDrain();
  }
  function mixedRow(target) {
    const row = target instanceof Element && target.closest('[data-ac-mixed-group]');
    return row?.dataset.acMixedGroup === GROUP ? row : null;
  }
  // A restored page can contain an old cart even when its radios are restored correctly.
  // Refresh the cart before its stale quantity controls can submit another change.
  let restoring = false;
  let restoreVersion = 0, restoreCleanup = null;
  let restoreFailed = false;
  let submissionVersion = 0;
  let pageRefreshPending = false;
  function pageMutationPending() {
    return changing || restoring || Boolean(document.querySelector(
      '#main-cart-items.cart__items--disabled, cart-drawer .cart__items--disabled, cart-items.cart__items--disabled, cart-items .cart__items--disabled, product-form button.loading, cart-drawer[data-ac-mixed-mutating], cart-items[data-ac-mixed-mutating], [data-ac-mixed-group][aria-busy="true"]'
    ));
  }
  function resumePageRefresh() {
    if (!pageRefreshPending || pageSuspended || pageMutationPending()) return;
    const page = document.querySelector('cart-items');
    if (!page?.isConnected) return;
    bindPageUpdates();
    pageRefreshPending = false;
    page.onCartUpdate();
  }
  function deferPageRefresh() {
    pageRefreshPending = true;
    queueMicrotask(resumePageRefresh);
  }
  function bindPageUpdates() {
    const page = document.querySelector('cart-items');
    if (!page || page.acMixedPageBound || typeof page.getSectionsToRender !== 'function') return;
    page.acMixedPageBound = true;
    let requestVersion = 0;
    page.onCartUpdate = async () => {
      if (!page.isConnected || pageSuspended) return;
      if (pageMutationPending()) { deferPageRefresh(); return; }
      const request = ++requestVersion, lifecycle = pageVersion, submission = submissionVersion;
      try {
        const sections = await readSections();
        if (!page.isConnected || pageSuspended || lifecycle !== pageVersion || request !== requestVersion) return;
        if (submission !== submissionVersion || pageMutationPending()) { deferPageRefresh(); return; }
        const replacements = page.getSectionsToRender().map(section => {
          const parsed = new DOMParser().parseFromString(sections[section.section] || '', 'text/html');
          const source = parsed.querySelector(section.selector);
          const container = document.getElementById(section.id);
          const target = container?.querySelector(section.selector) || container;
          if (!source || !target) throw Error('Could not refresh the cart.');
          return {target, html:source.innerHTML, parsed};
        });
        for (const {target,html} of replacements) target.innerHTML = html;
        const parsedPage = replacements[0].parsed.querySelector('cart-items');
        if (parsedPage) {
          const empty = parsedPage.classList.contains('is-empty');
          page.classList.toggle('is-empty', empty);
          document.getElementById('main-cart-footer')?.classList.toggle('is-empty', empty);
        }
      } catch (error) {
        if (pageSuspended || lifecycle !== pageVersion || request !== requestVersion || !page.isConnected) return;
        if (submission !== submissionVersion || pageMutationPending()) { deferPageRefresh(); return; }
        restoreFailed = true; page.setAttribute('data-ac-cart-uncertain','true');
        cartError(error.message || 'Could not refresh the cart.'); addRefreshButton();
      }
    };
  }
  const pageRefreshObserver = new MutationObserver(resumePageRefresh);
  pageRefreshObserver.observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['class','aria-busy','data-ac-mixed-mutating']});
  customElements.whenDefined('cart-items').then(bindPageUpdates);
  document.addEventListener('shopify:section:load', bindPageUpdates);
  document.addEventListener('submit', event => {
    if (restoreFailed && event.target instanceof Element && event.target.matches('#CartDrawer-Form, #cart')) {
      event.preventDefault();event.stopImmediatePropagation();restoreCart();return;
    }
    submissionVersion++;
  },true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('#CartDrawer-Form, #cart') || resumingCheckout) return;
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout' || (!drainPromise && !checkoutPending)) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    const checkoutVersion = pageVersion;
    let handedOff = false;
    const formId = form.id;
    submitter.classList.add('loading');
    submitter.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
    try {
      // No artificial delay: finish only the edits already requested by the customer.
      let failed = '';
      while (drainPromise) { await drainPromise;failed = failed || changeFailure; }
      if (failed || pageSuspended || checkoutVersion !== pageVersion) return;
      const currentForm = document.getElementById(formId);
      const currentButton = currentForm?.querySelector('[name="checkout"]') || document.querySelector(`[form="${formId}"][name="checkout"]`);
      if (!currentForm || !currentButton || currentButton.disabled) return;
      currentButton.classList.add('loading');
      currentButton.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      if (typeof checkoutLoad === 'function') checkoutLoad({currentTarget:currentButton});
      resumingCheckout = true;
      try { currentForm.requestSubmit(currentButton);handedOff = true; }
      finally { resumingCheckout = false; }
    } catch (_) {
      cartError('Could not finish updating your cart. Please try again.');
    } finally {
      checkoutPending = false;
      if (!handedOff) {
        submitter.classList.remove('loading');
        submitter.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      }
    }
  },true);
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('product-form button, .product-form__submit')) submissionVersion++;
  },true);
  function addRefreshButton() {
    const node = errorNode();
    if (!node) return;
    const retry = document.createElement('button');
    retry.type = 'button'; retry.textContent = 'Refresh cart';
    retry.addEventListener('click', restoreCart); node.append(retry);
  }
  async function restoreCart() {
    if (restoring || pageSuspended) return;
    if (changing) { reconcileAfterDrain = true; return; }
    const drawer = document.querySelector('cart-drawer');
    const page = document.querySelector('cart-items');
    if (!drawer && !page) return;
    restoring = true;
    const version = ++restoreVersion, lifecycle = pageVersion;
    const surfaces = [drawer,page].filter(Boolean).map(node => ({node,inert:node.inert}));
    surfaces.forEach(({node}) => {node.inert = true;node.setAttribute('aria-busy','true');});
    restoreCleanup = () => surfaces.forEach(({node,inert}) => {node.inert = inert;node.removeAttribute('aria-busy');});
    const beforeSubmission = submissionVersion;
    try {
      const [cart,sections] = await Promise.all([cartRequest('read'),readSections()]);
      cart.sections = sections;
      // A new add-to-cart owns the next render; never replace it with this older snapshot.
      if (pageSuspended || lifecycle !== pageVersion || version !== restoreVersion || beforeSubmission !== submissionVersion) return;
      await refreshCart(cart);
      if (pageSuspended || lifecycle !== pageVersion || version !== restoreVersion) return;
      restoreFailed = false;
      surfaces.forEach(({node}) => node.removeAttribute('data-ac-cart-uncertain'));
    } catch (_) {
      if (!pageSuspended && lifecycle === pageVersion && version === restoreVersion && beforeSubmission === submissionVersion) {
        restoreFailed = true;
        surfaces.forEach(({node}) => node.setAttribute('data-ac-cart-uncertain','true'));
        const node = errorNode();
        if (node) {
          node.textContent = 'Could not refresh your cart. ';
          const retry = document.createElement('button');
          retry.type = 'button';retry.textContent = 'Refresh cart';
          retry.addEventListener('click',restoreCart);node.append(retry);
        }
      }
    } finally {
      if (version === restoreVersion) {
        restoreCleanup?.(); restoreCleanup = null;
        restoring = false;
      }
    }
  }
  window.addEventListener('pagehide', () => {
    pageSuspended = true; pageVersion++; changes.clear(); pageRefreshPending = false;
    restoreCleanup?.(); restoreCleanup = null;
    restoreVersion++; restoring = false;
  });
  window.addEventListener('pageshow', event => {
    pageSuspended = false;
    const historyNavigation = window.performance?.getEntriesByType?.('navigation')?.[0]?.type === 'back_forward';
    if (event.persisted || historyNavigation) restoreCart();
  });
  document.addEventListener('click', event => {
    const remove = event.target instanceof Element && event.target.closest('cart-remove-button, a[href*="/cart/change"]');
    if (restoreFailed && remove?.closest('cart-drawer, cart-items')) {
      event.preventDefault();event.stopImmediatePropagation();restoreCart();return;
    }
    if (remove?.closest('cart-drawer, cart-items')) submissionVersion++;
    const row = remove && mixedRow(remove);
    if (!row) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (restoreFailed) { restoreCart(); return; }
    submissionVersion++;
    enqueue(row,0);
  },true);
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.quantity__input')) return;
    if (restoreFailed && input.closest('cart-drawer, cart-items')) {
      event.preventDefault();event.stopImmediatePropagation();input.value = input.defaultValue;restoreCart();return;
    }
    if (input.closest('cart-drawer, cart-items')) submissionVersion++;
    const row = mixedRow(input);
    if (!row) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (restoreFailed) { input.value = input.defaultValue;restoreCart();return; }
    submissionVersion++;
    const quantity = Number(input.value);
    if (!input.value.trim() || !Number.isSafeInteger(quantity) || quantity < 0 || (quantity > 0 && !input.checkValidity())) {
      input.value = input.defaultValue;
      cartError('Enter a valid whole-number quantity.');
      return;
    }
    enqueue(row,quantity);
  },true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["amencore-quantity-breaks-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  const roots = new Map();
  const rootSelector = 'quantity-breaks[data-section]';
  const collect = scope => [
    ...(scope instanceof Element && scope.matches(rootSelector) ? [scope] : []),
    ...scope.querySelectorAll(rootSelector)
  ];

    // Instance-only hooks: preserve Shrine's rendering, subscriptions and formatting.
    // Correct the underlying offer cache as well as the visible prices.
    function installPriceRounding(root) {
      if (!root.querySelector('[data-ac-discount-bps], [data-ac-per-book-floor]')) return () => {};
      const originals = new Map();
      function exactTotal(card) {
        if (!card || card.dataset.acDiscountBps === undefined) return null;
        const bps = Number(card.dataset.acDiscountBps);
        const quantity = Number(card.dataset.quantity);
        if (!Number.isInteger(bps) || bps < 0 || bps > 10000 ||
            !Number.isInteger(quantity) || quantity < 1) return null;
        let prices;
        const ids = root.selectedVariants && root.selectedVariants[card.dataset.input];
        if (root.hasVariants && ids && ids.length === quantity &&
            typeof root.getVariantData === 'function') {
          const variants = root.getVariantData();
          prices = ids.map(id => {
            const variant = variants.find(item => String(item.id) === String(id));
            return variant ? Number(variant.price) : NaN;
          });
        } else {
          prices = Array(quantity).fill(Number(root.dataset.basePrice));
        }
        if (prices.some(price => !Number.isSafeInteger(price) || price < 0 ||
            !Number.isSafeInteger(price * bps))) return null;
        const total = prices.reduce((sum, price) =>
          sum + price - Math.floor(price * bps / 10000), 0);
        return Number.isSafeInteger(total) ? total : null;
      }
      function correctCache(card) {
        const total = exactTotal(card);
        const key = 'offer_' + card.dataset.input.replace('input_', '');
        if (total !== null && root.offerPrices && root.offerPrices[key]) {
          root.offerPrices[key].price = total;
        }
        return total;
      }
      function correctAll() {
        root.querySelectorAll('[data-ac-discount-bps]').forEach(correctCache);
      }
      function wrap(name, factory) {
        const original = root[name];
        if (typeof original !== 'function') return;
        const own = Object.prototype.hasOwnProperty.call(root, name);
        const wrapped = factory(original);
        originals.set(name, { original, own, wrapped });
        root[name] = wrapped;
      }
      wrap('initOfferPrices', original => function(...args) {
        const result = original.apply(this, args);
        correctAll();
        return result;
      });
      wrap('updateDisplayedPdpPrices', original => function(...args) {
        correctAll();
        return original.apply(this, args);
      });
      wrap('updateLabelPrices', original => function(card, quantity, price, compare) {
        const total = correctCache(card);
        if (total !== null) price = this.applySubTo(total);
        const result = original.call(this, card, quantity, price, compare);
        if (card.dataset.acPerBookFloor === 'true' && quantity > 0 &&
            Number.isFinite(price) && typeof formatMoney === 'function') {
          const perBook = card.querySelector('.ac-per-book .variant-price-update');
          if (perBook) {
            perBook.innerHTML = formatMoney(Math.floor(Math.round(price) / quantity), this.moneyFormat, true);
          }
        }
        return result;
      });
      correctAll();
      // Update only opted-in cards once. Do not rewrite prices from a mutation observer.
      root.querySelectorAll('[data-ac-discount-bps], [data-ac-per-book-floor]').forEach(card => {
        const key = 'offer_' + card.dataset.input.replace('input_', '');
        const offer = root.offerPrices && root.offerPrices[key];
        if (offer && typeof root.updateLabelPrices === 'function') {
          root.updateLabelPrices(card, Number(card.dataset.quantity),
            root.applySubTo(offer.price), offer.compare_price);
        }
      });
      if (root.updatePdpPrices && typeof root.updateDisplayedPdpPrices === 'function') {
        root.updateDisplayedPdpPrices();
      }
      return () => {
        for (const [name, { original, own, wrapped }] of originals) {
          if (root[name] !== wrapped) continue;
          if (own) root[name] = original;
          else delete root[name];
        }
      };
    }

  function attach(root) {
    if (roots.has(root)) { roots.get(root).queue(); return; }
    let frame = 0;
    let destroyed = false;
    const sectionId = root.dataset.section;
    const form = root.querySelector('input[name="quantity"]')?.form;
    let restoreNative = false;
    let removePriceRounding = () => {};
    function restore() {
      restoreNative = true;
      queue();
    }
    function beforeSubmit() {
      cancelAnimationFrame(frame);
      frame = 0;
      restoreNative = true;
      sync();
    }
    function sync() {
      frame = 0;
      if (destroyed || !root.isConnected) return;
      const input = root.querySelector('input[type="radio"][name="quantity"]:checked:not(:disabled)');
      if (restoreNative) {
        restoreNative = false;
        if (input && typeof root.handleChange === 'function' &&
            (Number(root.selectedQuantity) !== Number(input.value) ||
             Number(root.selectedOffer) !== Number(input.dataset.input.replace('input_', '')))) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      const card = input && root.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      const source = card && card.querySelector('[data-ac-total]');
      const total = source ? source.textContent.trim() : '';
      const compareSource = card && card.querySelector('[data-ac-compare]');
      const compareTotal = compareSource ? compareSource.textContent.trim() : '';
      const showCompare = !!compareTotal && compareTotal !== total && !compareSource.classList.contains('hidden');
      document.querySelectorAll('[data-ac-cta-total][data-ac-section="' + CSS.escape(sectionId) + '"]').forEach(holder => {
        const button = holder.closest('button');
        holder.hidden = !total || (button && button.dataset.unavailable === 'true');
        const amount = holder.querySelector('[data-ac-cta-amount]');
        if (amount && amount.textContent !== total) amount.textContent = total;
        const comparison = holder.querySelector('[data-ac-cta-compare]');
        if (comparison) {
          comparison.hidden = !showCompare;
          if (comparison.textContent !== compareTotal) comparison.textContent = compareTotal;
        }
      });
      if (input && total) {
        const name = card.querySelector('.ac-tier-label');
        const nextLabel = (name ? name.textContent.trim() : '') + ' — ' + total;
        if (input.getAttribute('aria-label') !== nextLabel) input.setAttribute('aria-label', nextLabel);
      }
    }
    function queue() {
      if (!destroyed && !frame) frame = requestAnimationFrame(sync);
    }
    const observer = new MutationObserver(queue);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    const availabilityObserver = new MutationObserver(queue);
    if (form) {
      availabilityObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-unavailable'] });
      form.addEventListener('reset', restore);
      form.addEventListener('submit', beforeSubmit, true);
    }
    function upsellToggle(event) {
      if (!(event.target instanceof Element) || !event.target.closest('.quantity-break__upsell[data-toggle="true"]')) return;
      const selected = root.querySelector('input[name="quantity"]:checked:not(:disabled)');
      if (!selected) return;
      root.querySelectorAll('quantity-break-upsells').forEach(upsells => {
        if (typeof upsells.unlockGifts === 'function') upsells.unlockGifts(Number(selected.value), false);
      });
    }
    root.addEventListener('change', queue);
    root.addEventListener('click', upsellToggle);
    function bundleChange(event) {
      if (event.detail && event.detail.sectionId === sectionId) queue();
    }
    document.addEventListener('adult-bundle:change', bundleChange);
    roots.set(root, {
      destroy() {
        destroyed = true;
        removePriceRounding();
        cancelAnimationFrame(frame);
        observer.disconnect();
        availabilityObserver.disconnect();
        root.removeEventListener('change', queue);
        root.removeEventListener('click', upsellToggle);
        if (form) {
          form.removeEventListener('reset', restore);
          form.removeEventListener('submit', beforeSubmit, true);
        }
        document.removeEventListener('adult-bundle:change', bundleChange);
        roots.delete(root);
      },
      queue,
      restore
    });
    customElements.whenDefined('quantity-breaks').then(() => {         if (!destroyed) {
          removePriceRounding = installPriceRounding(root);
          restore();
        } });
    sync();
  }
  function boot(scope = document) {
    for (const [root, controller] of roots) if (!root.isConnected) controller.destroy();
    collect(scope).forEach(attach);
  }
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, controller] of roots) {
      if (event.target.contains(root)) controller.destroy();
    }
  });
  window.addEventListener('pageshow', () => {
    boot();
    for (const controller of roots.values()) controller.restore();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
